module.exports = __webpack_public_path__ + "static/media/productos_ingredientes_cacahuate_triturado.591fe7f2.png";